import { mapSourceToPublicRates } from './searchUtils'

export function isGuestPublicRatesSource(source: string | undefined): boolean {
  return !!source && mapSourceToPublicRates(source) === 'guest'
}

export function isGuestPublicRateSearchPrice(
  filters: App.OfferListFilters | undefined,
  pricing: App.OfferListMetadataPricing | undefined,
): boolean {
  return isGuestPublicRatesSource(filters?.source) && !!pricing?.lowestPriceIsPublic
}
